import { socketDefaults } from './defaults';

const socket = {
    ...socketDefaults,
    namespace: 'websocket',
    pathTemplate: 'api/v1/game/push/subscribe/gameday/{gamePk}'
};

const noDelaySocket = {
    ...socketDefaults,
    namespace: 'websocket',
    pathTemplate: 'api/v1/game/push/subscribe/{gamePk}'
};

export { socket, noDelaySocket };

export default socket;
